import {Component, inject, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {
  CurrentAdgroupSelectService,
  CurrentCampaignGroupSelectService,
  CurrentCampaignGroupSequenceSelectService, CurrentCampaignSelectService,
  CurrentSelectedSlugBehaviorService
} from '../objectPassingService';
import {getMatFormFieldMissingControlError} from '@angular/material/form-field'; // Import RouterModule
@Component({
  selector: 'app-nav-campaigns',
  templateUrl: './nav-campaigns.component.html',
  styleUrl: './nav-campaigns.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    AsyncPipe,
    RouterModule
  ]
})
export class NavCampaignsComponent implements OnInit {

  client_slug: string = '';
  private breakpointObserver = inject(BreakpointObserver);

  campaign_group_sequence_name: string = '';
  campaign_group_name: string = '';
  campaign_name: string = '';
  adgroup_name = '';


  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );



  constructor(
    private currentSelectedSlugBehaviorService: CurrentSelectedSlugBehaviorService,
    private router: Router,
    private renderer: Renderer2,
    private currentCampaignGroupSequenceSelectService: CurrentCampaignGroupSequenceSelectService,
    private currentCampaignGroupSelectService: CurrentCampaignGroupSelectService,
    private currentCampaignSelectService: CurrentCampaignSelectService,
    private currentAdgroupSelectService: CurrentAdgroupSelectService
  ) {



    this.currentSelectedSlugBehaviorService.currentSlugBehaviorAnnounced$.subscribe(x => {
      this.client_slug = x;
      console.log('NavCampaignsComponent currentSlugBehaviorAnnounced$', x)
    })

  }

  ngOnInit() {

    //this.currentCampaignGroupSequenceSelectService.announceCampaignGroupSequenceSelect(row.name);

    let client_slug = localStorage.getItem('client_slug');
    if (client_slug) {
      this.currentSelectedSlugBehaviorService.announceCurrentSlugBehavior(client_slug);
    } else {
      client_slug = null;
    }


    let campaign_group_sequence_name = localStorage.getItem('campaign_group_sequence_name');
    if (campaign_group_sequence_name) {
      this.currentCampaignGroupSequenceSelectService.announceCampaignGroupSequenceSelect(campaign_group_sequence_name);
    }
    let campaign_group_name = localStorage.getItem('campaign_group_name');
    if (campaign_group_name) {
      this.currentCampaignGroupSelectService.announceCampaignGroupSelect(campaign_group_name);
    }
    let campaign_name = localStorage.getItem('campaign_name');
    if (campaign_name) {
      this.currentCampaignSelectService.announceCampaignSelect(campaign_name);
    }
    let adgroup_name = localStorage.getItem('adgroup_name');
    if (adgroup_name) {
      this.currentAdgroupSelectService.announceAdgroupSelect(adgroup_name);
    }


    this.currentCampaignGroupSequenceSelectService.currentCampaignGroupSequenceSelectAnnounced$.subscribe(
      (campaign_group_sequence_name: string) => {
        console.log('AppComponent currentCampaignGroupSequenceSelectAnnounced$', campaign_group_sequence_name)
        this.campaign_group_sequence_name = campaign_group_sequence_name;

      }
    )
    this.currentCampaignGroupSelectService.currentCampaignGroupSelectAnnounced$.subscribe(
      (campaign_group_name: string) => {
        console.log('AppComponent currentCampaignGroupSelectAnnounced$', campaign_group_name)
        this.campaign_group_name = campaign_group_name;
      }
    )
    this.currentCampaignSelectService.currentCampaignSelectAnnounced$.subscribe(
      (campaign_name: string) => {
        console.log('AppComponent currentCampaignSelectAnnounced$', campaign_name)
        this.campaign_name = campaign_name;
      }
    )
    this.currentAdgroupSelectService.currentAdgroupSelectAnnounced$.subscribe(
      (adgroup_name: string) => {
        console.log('AppComponent currentAdgroupSelectAnnounced$', adgroup_name)
        this.adgroup_name = adgroup_name;
      }
    )



    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateActiveLink();
      }
    });

  } // end ngOnInit

  updateActiveLink() {
    const links = document.querySelectorAll('a[routerLink]');
    links.forEach(link => {
      if (link.getAttribute('href') === this.router.url) {
        this.renderer.addClass(link, 'active-link');
      } else {
        this.renderer.removeClass(link, 'active-link');
      }
    });
  }



} // end NavCampaignsComponent
